import React from 'react';
import useResourceEditProvider from './useResourceEditProvider';

export function withResourceEditProvider<P extends object>(WrappedComponent: React.FC<P>) {
  function withResourceEditProvider(props: P) {
    const context = useResourceEditProvider();
    return <WrappedComponent {...props} {...context} />;
  }
  return withResourceEditProvider;
}
